import { BuildingTypeEnum, Search } from "@/types/types";
import styles from "../page-searchbar.module.css";
import { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useDropdownPosition } from "@/hooks/use-dropdown-position";
import SelectorComponentListItem from "@/components/searchbars/selector-component-list-item";
import { usePageStore } from "../../../usePageStore";
import { IoIosArrowDown } from "react-icons/io";

export default function BuildingTypeSelectorClient({
  t,
  updateSearch,
  refetchState,
  fullWidth,
  isMobileStyle,
}: {
  t: any;
  updateSearch: <K extends keyof Search>(key: K, value: Search[K]) => void;
  refetchState: () => Promise<void>;
  fullWidth?: boolean;
  isMobileStyle?: boolean;
}) {
  const [isBuildingTypeOpen, setIsBuildingTypeOpen] = useState(false);
  const buildingTypeListRef = useRef<HTMLDivElement>(null);
  const buildingTypeListStyles = useDropdownPosition(
    buildingTypeListRef,
    isBuildingTypeOpen,
    {
      customWidth: 180, // px
      fullWidth: fullWidth,
    }
  );
  const activeBuildingType = usePageStore(
    (state) => state.search.building_type
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        buildingTypeListRef.current &&
        !buildingTypeListRef.current.contains(event.target as Node)
      ) {
        setIsBuildingTypeOpen(false); //this will close it
      }
    };
    if (isBuildingTypeOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isBuildingTypeOpen]);

  return (
    <div
      className={`${styles.selectWrapper} ${styles.buildingTypeItemWrapper} ${
        fullWidth && styles.fullWidth
      } ${isMobileStyle && styles.mobile}`}
      ref={buildingTypeListRef}
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          setIsBuildingTypeOpen(!isBuildingTypeOpen);
        }}
        className={`${styles.pill} ${isBuildingTypeOpen && styles.pillOpen}`}
      >
        <div className={styles.textWrapper}>
          <span>
            {activeBuildingType !== null && activeBuildingType !== undefined
              ? t(activeBuildingType)
              : t("buildingTypeTitle")}
          </span>
        </div>
        <span className={styles.chevron}>
          <IoIosArrowDown />
        </span>
      </button>
      {isBuildingTypeOpen && buildingTypeListStyles.top && (
        <ul
          className={`${styles.selectionList}`}
          style={buildingTypeListStyles}
        >
          <SelectorComponentListItem
            text={t("any")}
            icon={null}
            isActive={activeBuildingType === null}
            onClick={async () => {
              updateSearch("building_type", null);
              setIsBuildingTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t(BuildingTypeEnum.LOW_RISE)}
            icon={null}
            isActive={activeBuildingType === BuildingTypeEnum.LOW_RISE}
            onClick={async () => {
              updateSearch("building_type", BuildingTypeEnum.LOW_RISE);
              setIsBuildingTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t(BuildingTypeEnum.MID_RISE)}
            icon={null}
            isActive={activeBuildingType === BuildingTypeEnum.MID_RISE}
            onClick={async () => {
              updateSearch("building_type", BuildingTypeEnum.MID_RISE);
              setIsBuildingTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t(BuildingTypeEnum.HIGH_RISE)}
            icon={null}
            isActive={activeBuildingType === BuildingTypeEnum.HIGH_RISE}
            onClick={async () => {
              updateSearch("building_type", BuildingTypeEnum.HIGH_RISE);
              setIsBuildingTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
        </ul>
      )}
    </div>
  );
}
